import React from 'react'
import { useNavigate } from 'react-router-dom'
import './dashboard.css'

export function Dashboard() {
    const navli = useNavigate()
    return (
        <div className="dashCont">
            <div onClick={() => navli('/new')}>고객관리</div>
            <div onClick={() => navli('/deposit')}>입금</div>
            <div onClick={() => navli('/withdraw')}>출금</div>
            <div onClick={() => navli('/transfer')}>계좌이체</div>
            <div onClick={() => navli('/balance')}>현재자산</div>
        </div>
    )
}
export default Dashboard;